import * as React from "react";
import { Event } from "../../../../../contracts";
import { renderLiveScore } from "./renderLiveScore";
import { renderKickOffState } from "./renderKickOffState";
import { BaseDict } from "../../../dict";

export const renderLiveDetails = (event: Event, componentPrefix: string, dict: BaseDict) =>
    <>
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__scores`} data-uat={`div-ev-list-${componentPrefix}-scores`}>
            {renderLiveScore(event)}
        </div>
        {event.isInKickOffState && renderKickOffState(event, componentPrefix, dict)}
    </>
